<div class="card-container">
    <h2>Welcome to the McDermott Portal.</h2>
    <span>Please sign in start uploading files!</span>
    <p></p>
    <button #logoutbutton kendoButton style="border: #d7d6d6 1px solid" [svgIcon]="icons.login"
      (click)="loginRedirect()">
      Click here to Sign in.
    </button>
    <p>
        
    </p>
    
</div>